import { makeStyles } from '@material-ui/core';
import HorStep from './HorStep';

export default function HorStepper(props) {

    const classes = useStyles();
    let steps = []
    if (props.steps) {
        steps = props.steps.map((p) => (<HorStep currentstep={props.addPage.horStep} actions={props.actions} key={p.id} {...p}></HorStep>));
    }

    return (
        <div className={classes.container}>
            {steps}
        </div>
    )
}



const useStyles = makeStyles({
    container: {
        flexDirection: "row",
        padding: 15,
        backgroundColor: "#F5F5F5",
        height:"80px"
    }
});